import { FC } from "react";
import { useTranslation } from "react-i18next";

import { PassengerDeleteResultEnum } from "@ryde/shared";

import { ModalFooterStyled, MuiButton } from "../../controls";

interface IPassengerDeleteKeepBookingFooterProps {
  onResult: (result: PassengerDeleteResultEnum) => () => void;
}

// Rendered when `markBookingAsNewOnPassengerRemoved` is enabled: a plain
// Cancel/OK confirmation where OK removes the passenger and keeps the booking
// in the NEW status (mirrors the ride-deletion behavior).
export const PassengerDeleteKeepBookingFooter: FC<
  IPassengerDeleteKeepBookingFooterProps
> = ({ onResult }) => {
  const { t } = useTranslation();

  return (
    <ModalFooterStyled>
      <MuiButton
        muiStyle={"primary"}
        muiVariant={"outlined"}
        onClick={onResult(PassengerDeleteResultEnum.NoAction)}
        e2eData="cancel-modal-button"
      >
        {t(`general.CANCEL`)}
      </MuiButton>

      <MuiButton
        onClick={onResult(PassengerDeleteResultEnum.NewBooking)}
        e2eData="ok-booking-button"
      >
        {t(`general.OK`)}
      </MuiButton>
    </ModalFooterStyled>
  );
};
